<div class="chat-trigger" [class.hidden]="open">
  <div class="chat-trigger-button-container">
    <button mat-icon-button class="chat-trigger-button" (click)="openChat()">
      <!-- <mat-icon svgIcon="esperanto-ia"></mat-icon> -->
      <img loading="lazy" src="../../../../assets/img/logo_esperant-ia.webp">
    </button>
  </div>
</div>

<main class="chat {{zoom}}" [class.open]="open" class="first-time" id="__chat_esperanto">

  <header class="chat-header">
    <div class="chat-logo">
      <!-- <img loading="lazy" src="../../../../assets/img/logo_chat.svg"> -->
      <img loading="lazy" src="../../../../assets/img/logo_esperant-ia.webp">
      <span>{{'chat.title' | translate }}</span>
    </div>
    <div class="chat-actions">
      <button mat-icon-button (click)="toggleZoom()" class="zoom-btn">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M16 4l4 0l0 4" />
          <path d="M14 10l6 -6" />
          <path d="M8 20l-4 0l0 -4" />
          <path d="M4 20l6 -6" />
        </svg>
      </button>
      <button mat-icon-button (click)="clearChat()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
          <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
          <path d="M16 5l3 3" />
        </svg>
      </button>
      <button mat-icon-button (click)="closeChat()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M18 6l-12 12" />
          <path d="M6 6l12 12" />
        </svg>
      </button>
    </div>
  </header>

  <div class="chat-content">

    <section class="chat-history">
      <div *ngFor="let msg of chatHistory">
        @if (msg.role === 'user') {
        <div class="user-message">
          {{ msg.content }}
        </div>
        } @else {
        <div class="assistant-message">
          <div class="message">
            <!-- <img loading="lazy" src="../../../../assets/img/logo_chat.svg" class="chat-logo"> -->
            <img loading="lazy" src="../../../../assets/img/logo_esperant_ia_xs.webp" class="chat-logo">

            <div class="message-content">
              <div [innerHTML]="msg.content"></div>

              <div *ngIf="msg.references?.length" class="references">
                <hr />
                <p><strong>{{ 'chat.references' | translate }}</strong></p>
                <ul>
                  <ng-container *ngFor="let ref of msg.references; let i = index">
                    <li *ngIf="ref?.url">
                      [{{ i }}]
                      <a *ngIf="ref.externa" [href]="ref.url" target="_blank" rel="noopener noreferrer">
                        {{ ref.title || ref.url }}
                      </a>
                      <a *ngIf="!ref.externa" [routerLink]="ref.url">
                        {{ ref.title || ref.url }}
                      </a>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      <div class="waiting" *ngIf="waiting">
        <mat-spinner [diameter]="18" [strokeWidth]="2"></mat-spinner>
        <span>{{'chat.waiting' | translate}}</span>
      </div>
    </section>

    <footer class="chat-input">
      <form [formGroup]="form" class="chat-input-form">
        <div class="chat-input-row">
          <mat-form-field class="chat-input-field">
            <textarea matInput formControlName="text" rows="1" placeholder="{{'chat.text' | translate}}" #inputMessage
              (keydown.enter)="onEnter($event)"></textarea>
          </mat-form-field>
          <button mat-icon-button (click)="send()" [disabled]="form.invalid">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" />
            </svg>
          </button>
        </div>
      </form>
      <p class="chat-warning">
        {{'chat.warningAI' | translate}}
        <span class="link" (click)="openLegalAI()">{{'chat.legalAI'|translate}}</span>.
      </p>
    </footer>

  </div>

</main>